export const SegmentationsHatchPatterns = () => (
  <>
    <svg width="0" height="0">
      <pattern
        id="calculus-fill"
        patternUnits="userSpaceOnUse"
        width="70"
        height="70"
      >
        <image
          xlinkHref="/assets/images/hatch.svg"
          x="0"
          y="0"
          width="70"
          height="70"
        />
      </pattern>
    </svg>
    <svg width="0" height="0">
      <pattern
        id="ral-fill"
        patternUnits="userSpaceOnUse"
        width="70"
        height="70"
      >
        <image
          xlinkHref="/assets/images/ralHatch.svg"
          x="0"
          y="0"
          width="70"
          height="70"
        />
      </pattern>
    </svg>
  </>
);
